<div class="header">
  <h3 class="credit-offer-title heading-s-bold m-0">
    {{
    offer?.offerType === 'BEFH_CTA'
    ? 'Boost your credit score, budget better, and manage debt smarter'
    : 'Best Egg Visa® Credit Card'
    }}
  </h3>

  <div>
    @if (offer?.offerType !== 'BEFH_CTA') {
      <p class="be-body-text--sm my-4">
        {{ offer?.heading }}
      </p>
    } @else {
      <p class="be-body-text--sm my-4" [innerHTML]="offer?.heading"></p>
      } @if (offer?.offerType !== 'BEFH_CTA') {
      @if (offer.offerType !== 'RESUME_APPLICATION') {
        <button
          class="offer-disclosures btn-nude be-body-text--sm"
          (click)="openDisclosureModal()"
          >
          {{ offer?.label }}
        </button>
      }
      @if (offer.offerType === 'RESUME_APPLICATION') {
        <a
          [href]="offer.offerUrl"
          target="_blank"
          class="offer-disclosures btn-nude be-body-text--sm"
          >
          {{ offer?.label }}
        </a>
      }
    }
  </div>

  <div class="content-wrapper">
    <div>
      @if (offer.offerType !== 'RESUME_APPLICATION') {
        <button
          class="be-btn be-btn--small btn-margin"
        [ngClass]="{
          'be-btn--ghost': offer?.offerType === 'BEFH_CTA'
        }"
          (click)="onGetOffer()"
          >
          {{ offer?.callToAction || 'Get offer' }}
        </button>
      }
    </div>
    @if (
      offer?.productType === 'CREDIT_CARD' && offer?.offerType !== 'BEFH_CTA'
      ) {
      <img
        class="credit-card-icon"
        src="assets/icons/blue_card.svg"
        alt="blue credit card"
        />
    }
    <!-- TODO: these need to be updated when the ENUM values for different offers are updated -->
    @if (offer?.offerType === 'CREDIT_CARD_RED') {
      <img
        class="credit-card-icon"
        src="assets/icons/red_card.svg"
        alt="red credit card"
        />
    }
    @if (offer?.offerType === 'HOME_LOAN') {
      <img
        class="credit-card-icon"
        src="assets/icons/house.svg"
        alt="house"
        />
    }
  </div>
</div>
